module.exports = __webpack_public_path__ + "static/far_v2_abstract_cube_no_logo_wbx-655f10239a50b2f1022b09f9a088c31f.jpg";